import { render, staticRenderFns } from "./ProductHistoryItem.vue?vue&type=template&id=20216540&scoped=true"
import script from "./ProductHistoryItem.vue?vue&type=script&lang=js"
export * from "./ProductHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./ProductHistoryItem.vue?vue&type=style&index=0&id=20216540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20216540",
  null
  
)

export default component.exports